import { gql } from "@apollo/client";

export const ADMIN_HEALTH_SYNC_MONITORING = gql`
  query AdminHealthSyncMonitoring(
    $status: String
    $provider: String
    $first: Int
    $skip: Int
  ) {
    adminHealthSyncMonitoring(
      status: $status
      provider: $provider
      first: $first
      skip: $skip
    ) {
      devices {
        userId
        provider
        connected
        syncEnabled
        lastSyncAt
        status
        hoursSinceLastSync
      }
      stats {
        totalDevices
        healthyCount
        warningCount
        criticalCount
        neverSyncedCount
        disconnectedCount
      }
      lastNudgeStats {
        lastNudgeAt
        totalTokens
        sent
        failed
        durationMs
        failedUsers {
          userId
          errorType
        }
      }
      totalCount
    }
  }
`;
